import { ITreeTradeArray } from 'models/treeTradeActivity';

export interface ITreeTradeData {
  getTreeTrade: {
    config: {
      isLoading: boolean;
    };
    treeTrade: ITreeTradeArray[];
  };
}

const treeTradeInitialState: ITreeTradeData = {
  getTreeTrade: {
    config: {
      isLoading: false,
    },
    treeTrade: [],
  },
};

export default treeTradeInitialState;
